import { installLensHostUriProtocol } from "./lensHostUriProtocol.js";
export const LENS_HOST_URI_PLUGIN = "lens-host-uri";
export function createLensHostUriPlugin({ onEvent = () => undefined } = {}) {
    return {
        name: LENS_HOST_URI_PLUGIN,
        async setup({ engine }) {
            const controller = await installLensHostUriProtocol(engine, onEvent);
            return {
                service: controller,
                dispose: () => controller.dispose(),
            };
        },
    };
}
//# sourceMappingURL=lensHostUriPlugin.js.map